export const sortDataPoints = <T extends { time: string }>(points?: T[]) =>
  points ? points.sort((a, b) => (a.time > b.time ? 1 : -1)) : [];
